import { RouteConfig } from 'vue-router';

export const epuapSignFaliureRoute: RouteConfig = {
  path: 'sign_failure',
  name: 'epuapSignFaliure',
  component: () => import(/* webpackChunkName: "SignResult" */ '@/views/mainRoute/document/epuap/SignResult.vue'),
  meta: { breadcrumb: { title: 'Stan podpisu' } }
};
